import styled from "@emotion/styled";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { ReactComponent as InfoIcon } from "Components/_Shared/Icons/Assets/info.svg";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";

type Props = {
  readonly stateAid: boolean;
  readonly liabilities: boolean;
};

const StyledHint = styled(Box)`
  ${({ theme }) => `
    box-sizing: border-box;
    background-color: #FFFBD1;
    padding: ${theme.spacing(Spacing.L)};
    border-radius: ${theme.spacing(Radius.L)};
    width: 100%;
  `}
`;

export const InsuranceWarning: React.FC<Props> = ({ stateAid, liabilities }) => {
  if (!stateAid && !liabilities) return null;
  return (
    <StyledHint>
      <Grid container justifyContent="space-between">
        <Grid size={0.4}>
          <Box
            display="flex"
            alignItems="center"
            sx={{
              transform: "scaleY(-1)",
            }}
          >
            <InfoIcon color="#F5D90A" />
          </Box>
        </Grid>
        <Grid size={1}>
          <Box display="flex" alignItems="center">
            <Typography variant="body2" color="#946800" fontWeight={500} lineHeight={1.4}>
              Varování
            </Typography>
          </Box>
        </Grid>
        <Grid size={10.4}>
          <Stack>
            {stateAid && (
              <Typography variant="body2" color="#946800" lineHeight={1.4}>
                Vyplňte hodnoty státní podpory.
              </Typography>
            )}
            {liabilities && (
              <Typography variant="body2" color="#946800" lineHeight={1.4}>
                U nesplaceného úvěru klienta není uvedena splatnost.
              </Typography>
            )}
          </Stack>
        </Grid>
      </Grid>
    </StyledHint>
  );
};
